<style>
</style>

<template>
  <div class="Create alignment">

    <template>
      <v-flex
        xs12
        sm12
      >
        <h3
          v-if="edit"
          class="styleHeader"
          style="margin-bottom: 31px"
        >Procedura - Modifica</h3>
        <h3
          v-else
          class="styleHeader"
          style="margin-bottom: 31px"
        >Procedura - Aggiungi</h3>
        <v-card class="styleDataTable">
          <form>
            <v-text-field
              v-model="Name"
              label="Nome"
              required
              :error-messages="NameErrors"
              @input="$v.Name.$touch()"
              @blur="$v.Name.$touch()"
            ></v-text-field>

            <!-- " 
            @blur="$v.StoredProcedure.$touch()"-->
            <v-autocomplete
              class="styleAlignementCard"
              v-model="StoredProcedure"
              label="Stored Procedure"
              required
              :disabled="isEditing"
              :error-messages="StoredProcedureErrors"
              v-bind:items="StoredProcedures"
              :loading="LoadingStoredProcedure"
              @input.native="LoadStoredProcedure"
              item-text="name"
              item-value="name"
              @change="ChangeStoredProcedure"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                {{ data.item }}
              </template>
            </v-autocomplete>
            <v-textarea
              v-model="Description"
              label="Description"
              required
              :error-messages="DescriptionErrors"
              @input="$v.Description.$touch()"
              @blur="$v.Description.$touch()"
            ></v-textarea>
          </form>
        </v-card>

        <div
          v-for="i in ProceduresParametersData.length"
          :key="i"
        >
          <paramsComponent
            :Parameter="ProceduresParametersData[i-1]"
            v-if="ProceduresParametersData[i-1].isVisible"
            :spId="getId()"
            :ref="'counterParams-'+i"
          >
          </paramsComponent>
        </div>

        <v-btn
          class="white--text styleButtonTop styleAlignementSaveButton"
          @click="submit()"
          color="#5c6366"
        >
          <v-icon left>check_circle</v-icon>
          Salva
        </v-btn>
        <v-btn
          class="styleButtonTop"
          @click="back()"
        >
          <v-icon left>remove_circle</v-icon>
          Annulla
        </v-btn>
      </v-flex>
      <v-alert
        :value="errorAlert"
        type="error"
        transition="scale-transition"
      >{{
        errorMessage
      }}</v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import router from "@/router/index.js";
import debounce from "debounce";
import companiesApi from "../../apiLogisticsTool/companiesApi.js";
import operatorsApi from "../../apiLogisticsTool/operatorsApi.js";
import proceduresApi from "../../apiLogisticsTool/proceduresApi.js";
import proceduresParamatersApi from "../../apiLogisticsTool/procedureParametersApi.js";
import { error } from "util";
import paramsComponent from "../../components/paramsComponent.vue";

export default {
  mixins: [validationMixin],
  validations: {
    StoredProcedure: { required },
    Description: { required },
    Name: { required }
  },

  data: () => ({
    id: 0,
    isEditing: false,
    StoredProcedure: "",
    StoredProcedures: [],
    LoadingStoredProcedure: false,
    SelectedStoredProcedure: "",
    ProceduresParametersData: [],
    Name: "",
    Description: "",
    errorAlert: false,
    errorMessage: "",
    msgInsertError: "Elemento richiesto",

    Procedures: {},
    Procedure: {
      Id: "",
      Name: "",
      Description: "",
      StoredProcedure: ""
    },

    ProceduresParameters: {
      Id: "",
      ProcedureId: "", // id della procedura a cui è collegato il parametro FK
      Label: "", // label associata al parametro
      WidgetId: "", // id del widget associato FK
      ParameterName: "", // nome del parametro della stored (@Param1)
      ParameterDataType: "", // data type del parametro della stored (nvarchar)
      ParameterLenght: "" // lungezza del parametro della stored (50)
    }
  }),

  components: {
    paramsComponent
  },

  computed: {
    edit() {
      return this.$route.params.Id > 0;
    },

    StoredProcedureErrors() {
      const errors = [];
      if (!this.$v.StoredProcedure.$dirty) return errors;
      !this.$v.StoredProcedure.required && errors.push(this.msgInsertError);
      return errors;
    },
    DescriptionErrors() {
      const errors = [];
      if (!this.$v.Description.$dirty) return errors;
      !this.$v.Description.required && errors.push(this.msgInsertError);
      return errors;
    },
    NameErrors() {
      const errors = [];
      if (!this.$v.Name.$dirty) return errors;
      !this.$v.Name.required && errors.push(this.msgInsertError);
      return errors;
    }
  },

  created() {
    const id = this.$route.params.Id;

    //se abbiamo l'id compilo i campi che sono già esistenti
    if (id) {
      this.isEditing = true;

      proceduresApi.GetProcedure(id).then(response => {
        this.Name = response.data.name;
        this.Description = response.data.description;
        this.StoredProcedures = [response.data.storedProcedure];
        this.StoredProcedure = response.data.storedProcedure;
      });

      proceduresParamatersApi.GetProcedureParametersById(id).then(response => {
        this.ProceduresParametersData = response.data;
      });

      //
    } else {
      this.ProceduresParametersData = {};
    }
  },

  methods: {
    getId() {
      return this.$route.params.Id;
    },

    back() {
      router.push("/Procedures/Index");
    },

    ChangeStoredProcedure(event) {
      if (event) {
        //TODO chiamo il metodo per trovare i param
        proceduresApi.GetInfromationParameters(event).then(response => {
          //TODO, salvarmi i dati in un oggett/array
          this.ProceduresParametersData = response.data;
          //console.log("ProceduresParametersData", this.ProceduresParametersData);
          //parameterName
          // if (id) {
          // }
        });
      }
    },

    LoadStoredProcedure: debounce(function(event) {
      if (event.target.value.length > 2) {
        this.LoadingStoredProcedure = true;
        var sp = event.target.value;

        proceduresApi.GetProceduresStockAddOn(sp).then(({ data }) => {
          this.StoredProcedures = data;

          this.LoadingStoredProcedure = false;
        });
      }
    }, 200),

    submit() {
      const id = this.$route.params.Id;

      let paramsList = [];
      let parameterOk = true;

      for (var i = 0; i < this.ProceduresParametersData.length; i++) {
        let counter = i + 1;
        let param = {};

        if (this.ProceduresParametersData[i].isVisible) {
          param = this.$refs["counterParams-" + counter][0].passData();

          this.$refs["counterParams-" + counter][0].validate();

          // parameter validation
          if ((param.Label == "" || param.WidgetId == "") && parameterOk)
            parameterOk = false;
        } else {
          param = {
            ParameterName: this.ProceduresParametersData[i].parameterName,
            Label: this.ProceduresParametersData[i].parameterName,
            WidgetId: 1,
            IsRequired: false,
            ParameterLenght: this.ProceduresParametersData[i]
              .characteR_MAXIMUM_LENGTH,
            ParameterDataType: this.ProceduresParametersData[i].datA_TYPE,
            IsOutput: this.ProceduresParametersData[i].parameteR_MODE == "INOUT"
          };
        }

        //console.log(param);
        param.isVisible = this.ProceduresParametersData[i].isVisible;
        paramsList.push(param);
      }

      let apiArg = {
        parameterList: paramsList,
        Id: id,
        Name: this.Name,
        Description: this.Description,
        StoredProcedure: this.StoredProcedure
      };

      //controllo gli errori
      this.$v.$touch();
      if (
        this.$v.Name.$error ||
        this.$v.StoredProcedure.$error ||
        this.$v.Description.$error ||
        !parameterOk
      ) {
        console.log("validation errors found");
        return;
      }

      proceduresApi
        .InsertProcedureWithParameters(apiArg)
        .then(() => {
          this.$emit("refreshMenu", this.refreshMenu);
          router.push("/Procedures/Index");
        })
        .catch(error => {
          this.errorAlert = true;
          this.errorMessage = error.response.data;
        });
    },

    clear() {
      this.$v.$reset();
      this.Companies = "";
      this.Email = "";
      this.Name = "";
      this.Description = "";
      this.Surname = "";
    }
  }
};
</script>
